"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PageNavigator = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = _interopRequireWildcard(require("react"));
var _constants = require("../../constants");
var _useOverviewContext = require("../../hooks/useOverviewContext");
var _usePageNumberContext = require("../../hooks/usePageNumberContext");
var _useToggle = require("../../hooks/useToggle");
var _useTranslations = require("../../hooks/useTranslations");
var _PageCounter = require("../PageCounter");
var _constants2 = require("./constants");
var _getPageNumber = require("./getPageNumber");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return (_interopRequireWildcard = function(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(const t in e)"default" !== t && ({}).hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
        return f;
    })(e, t);
}
const Root = (0, _mui.styled)(_mui.TextField)((param)=>{
    let { theme } = param;
    return {
        width: '85px',
        '.page-navigator-input': {
            padding: theme.spacing(2),
            textAlign: 'center',
            '&::-webkit-outer-spin-button': {
                WebkitAppearance: 'none',
                margin: 0
            },
            '&::-webkit-inner-spin-button': {
                WebkitAppearance: 'none',
                margin: 0
            }
        }
    };
});
const PageNavigator = exports.PageNavigator = /*#__PURE__*/ (0, _react.memo)(()=>{
    const [isInputMode, toggleInputMode] = (0, _useToggle.useToggle)(false);
    const { changePageNumber, currentPages, totalPageCount, currentPagesInitialized } = (0, _usePageNumberContext.usePageNumberContext)();
    const { getTestId } = (0, _testidGenerator.default)();
    const { translations } = (0, _useTranslations.useTranslations)();
    const { isOverviewOpen } = (0, _useOverviewContext.useOverviewContext)();
    const pageNumber = (0, _react.useMemo)(()=>(0, _getPageNumber.getPageNumber)(currentPages), [
        currentPages
    ]);
    const onBlurHandler = (0, _react.useCallback)((event)=>{
        changePageNumber(event.target.value);
        toggleInputMode();
    }, [
        changePageNumber,
        toggleInputMode
    ]);
    const onKeyDownHandler = (0, _react.useCallback)((event)=>{
        if (event.key === 'Enter') {
            changePageNumber(event.target.value);
            toggleInputMode();
        }
    }, [
        changePageNumber,
        toggleInputMode
    ]);
    if (isInputMode && !isOverviewOpen) {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Root, {
            autoFocus: true,
            type: "number",
            focused: false,
            variant: "outlined",
            inputProps: {
                [_constants.ARIA_LABEL]: translations.navigatorInput,
                className: 'page-navigator-input',
                inputMode: 'numeric'
            },
            "data-testid": getTestId(_constants2.NAVIGATION),
            onBlur: onBlurHandler,
            onKeyDown: onKeyDownHandler
        });
    }
    if (totalPageCount < 1 || !currentPagesInitialized) {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Skeleton, {
            "data-testid": getTestId(_constants2.NAVIGATION_SKELETON),
            animation: "pulse",
            variant: "rectangular",
            height: 21,
            width: 43
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_PageCounter.PageCounter, {
        pageNumber: pageNumber,
        toggleInputMode: toggleInputMode,
        totalPageCount: totalPageCount
    });
});
